// src/components/LoyaltyProgramSteps/Step4ReviewLaunch.js
import React from 'react';
import { CheckCircleIcon, GiftIcon, CalculatorIcon, ReceiptPercentIcon } from '@heroicons/react/24/outline';

const Step4ReviewLaunch = ({ formData }) => {
    const getProgramTypeLabel = (type) => {
        switch (type) {
            case 'points': return 'Points-based';
            case 'tier': return 'Tier-based';
            case 'stamp': return 'Stamp Card';
            case 'spend': return 'Spend-based';
            default: return 'Unknown';
        }
    };

    return (
        <fieldset className="border p-4 rounded-md space-y-4">
            <legend className="text-lg font-medium text-gray-900 flex items-center">
                <CheckCircleIcon className="h-6 w-6 text-indigo-500 mr-2" />
                Step 4: Review & Launch
            </legend>

            <div className="space-y-6">
                {/* Program Details Summary */}
                <div className="border border-gray-200 rounded-md p-4 bg-gray-50">
                    <h3 className="text-lg font-semibold text-gray-800 flex items-center mb-3">
                        <GiftIcon className="h-5 w-5 text-indigo-500 mr-2" /> Program Details
                    </h3>
                    <p><strong>Name:</strong> {formData.programName || 'N/A'}</p>
                    <p><strong>Description:</strong> {formData.programDescription || 'N/A'}</p>
                    <p><strong>Type:</strong> {getProgramTypeLabel(formData.programType) || 'N/A'}</p>
                    {formData.startDate && <p><strong>Start Date:</strong> {formData.startDate}</p>}
                    {formData.endDate && <p><strong>End Date:</strong> {formData.endDate}</p>}
                </div>

                {/* Earning Rules Summary */}
                <div className="border border-gray-200 rounded-md p-4 bg-gray-50">
                    <h3 className="text-lg font-semibold text-gray-800 flex items-center mb-3">
                        <CalculatorIcon className="h-5 w-5 text-indigo-500 mr-2" /> Earning Rules
                    </h3>
                    {formData.programType === 'points' && (
                        <p>Earn {formData.pointsPerSpend} points for every R{formData.spendAmount} spent.</p>
                    )}
                    {formData.programType === 'stamp' && (
                        <p>Collect {formData.stampsNeeded} stamps for a reward.</p>
                    )}
                    {formData.programType === 'spend' && (
                        <p>Reach a spend threshold of R{formData.spendThreshold} for a reward.</p>
                    )}
                    {formData.programType === 'tier' && (
                        <p className="text-sm text-gray-600">Tier progression rules defined in Tier Management (Future feature).</p>
                    )}
                    {formData.earningExclusions && <p><strong>Exclusions:</strong> {formData.earningExclusions}</p>}
                </div>

                {/* Rewards & Redemption Summary */}
                <div className="border border-gray-200 rounded-md p-4 bg-gray-50">
                    <h3 className="text-lg font-semibold text-gray-800 flex items-center mb-3">
                        <ReceiptPercentIcon className="h-5 w-5 text-indigo-500 mr-2" /> Rewards & Redemption
                    </h3>
                    {formData.programType === 'points' && formData.rewards && formData.rewards.length > 0 ? (
                        <ul className="list-disc pl-5 space-y-2">
                            {formData.rewards.map((reward, index) => (
                                <li key={index}>
                                    <strong>{reward.pointsNeeded} Points:</strong> {reward.rewardDescription} ({reward.value} {reward.rewardType === 'discount' ? 'off' : reward.rewardType === 'percentage_discount' ? '%' : ''})
                                </li>
                            ))}
                        </ul>
                    ) : formData.programType === 'stamp' && formData.stampRewardDescription ? (
                        <p><strong>Reward:</strong> {formData.stampRewardDescription} ({formData.stampRewardValue})</p>
                    ) : formData.programType === 'spend' && formData.spendRewardDescription ? (
                        <p><strong>Reward:</strong> {formData.spendRewardDescription} ({formData.spendRewardValue})</p>
                    ) : formData.programType === 'tier' ? (
                        <p className="text-sm text-gray-600">Rewards are defined per tier (Future feature).</p>
                    ) : (
                        <p>No rewards configured.</p>
                    )}
                    {formData.redemptionInstructions && <p className="mt-3"><strong>Redemption Instructions:</strong> {formData.redemptionInstructions}</p>}
                </div>
            </div>

            <div className="mt-4 text-center text-sm text-gray-600">
                Please review all the details above. Once launched, your loyalty program will be active!
            </div>
        </fieldset>
    );
};

export default Step4ReviewLaunch;